import {
  UserRoles,
  ApiUserRoles,
  UserRolesByApiUserRole,
  type UserRoleContext,
} from '@/contexts/shared/users/roles/UserRoles.interfaces'

export const getUserRoleNameByApiUserRole = (
  apiUserRole: ApiUserRoles,
  userContext?: UserRoleContext
): UserRoles | undefined => {
  if (apiUserRole === ApiUserRoles.PILOT) {
    return userContext?.isGlobalAdmin ? UserRoles.GLOBAL_PILOT : UserRoles.LOCAL_PILOT
  }

  if (apiUserRole === ApiUserRoles.AUDITOR) {
    return userContext?.isGlobalAuditor ? UserRoles.GLOBAL_AUDITOR : UserRoles.LOCAL_AUDITOR
  }

  return UserRolesByApiUserRole[apiUserRole]
}
